import { idmsApi } from "./api";
import {
  API_SEND_OTP_ENDPOINT,
  API_VERIFY_OTP_ENDPOINT,
} from "../../constants/endpoints";

export enum OtpChannel {
  Email = 0,
  Sms = 1,
  Both = 2,
}

export interface SendOtpRequest {
  email: string;
  phoneNumber?: string;
  dealerGuid: string;
  productId: string;
}

export interface SendOtpResponse {
  success: boolean;
  sessionId?: string;
  message: string;
  otpExpiresAt?: string;
  maskedEmail?: string;
  maskedPhoneNumber?: string;
  channel: OtpChannel;
}

export interface VerifyOtpLoginRequest {
  sessionId: string;
  otpCode: string;
  clientId: string;
  clientSecret: string;
  productId: string;
}

export interface LoginResponse {
  access_token: string;
  expires_in: number;
  token_type: string;
  refresh_token: string;
  scope: string;
}

const otpApi = idmsApi.injectEndpoints({
  endpoints: (builder) => ({
    // Send OTP to email or phone
    sendOtp: builder.mutation<SendOtpResponse, SendOtpRequest>({
      query: (request) => ({
        url: API_SEND_OTP_ENDPOINT,
        method: "POST",
        body: request,
      }),
    }),

    // Verify OTP and get login token
    verifyOtp: builder.mutation<LoginResponse, VerifyOtpLoginRequest>({
      query: (request) => ({
        url: API_VERIFY_OTP_ENDPOINT,
        method: "POST",
        body: request,
      }),
    }),
  }),
});

export const {
  useSendOtpMutation,
  useVerifyOtpMutation,
} = otpApi;
